import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Globe } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const LanguageSwitcher = () => {
  const { lang, setLang, languages } = useLang();
  return (
    <div className="flex items-center gap-2" data-testid="language-switcher">
      <Globe className="h-4 w-4 text-slate-500" />
      <Select value={lang} onValueChange={setLang}>
        <SelectTrigger
          className="h-9 w-[130px] rounded-none border-slate-300 text-sm font-medium uppercase tracking-wide"
          data-testid="language-select-trigger"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="rounded-none">
          {languages.map((l) => (
            <SelectItem key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>
              {l.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
